import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, addDoc, onSnapshot, doc } from 'firebase/firestore';
import './ComposeLetter.css';

const ComposeLetter = ({ onLetterSent, onBack }) => {
  const [recipient, setRecipient] = useState('');
  const [message, setMessage] = useState('');
  const [fromName, setFromName] = useState('');
  const [partner, setPartner] = useState(null);
  const [currentUserNickname, setCurrentUserNickname] = useState('');

  // Fetch current user's nickname and partner info
  useEffect(() => {
    if (!auth.currentUser) {
      console.log("ComposeLetter: No authenticated user found.");
      return;
    }
    console.log("ComposeLetter: Current user ID:", auth.currentUser.uid);

    const userDocRef = doc(db, 'users', auth.currentUser.uid);

    const unsubscribe = onSnapshot(userDocRef, (userDoc) => {
      if (userDoc.exists()) {
        const userData = userDoc.data();
        console.log("ComposeLetter: Current user data:", userData);
        setCurrentUserNickname(userData.nickname || '');

        if (userData.partnerId) {
          console.log("ComposeLetter: Found partnerId:", userData.partnerId);
          const partnerDocRef = doc(db, 'users', userData.partnerId);
          
          const partnerUnsubscribe = onSnapshot(partnerDocRef, (partnerDoc) => {
            if (partnerDoc.exists()) {
              const partnerData = partnerDoc.data();
              console.log("ComposeLetter: Successfully fetched partner data:", partnerData);
              setPartner({ id: partnerDoc.id, ...partnerData });
              setRecipient(partnerDoc.id);
            } else {
              console.log("ComposeLetter: Partner document not found for ID:", userData.partnerId);
              setPartner(null);
            }
          });
          
          // Return the partner unsubscribe function to be called when the main effect cleans up
          return () => {
            console.log("ComposeLetter: Unsubscribing from partner listener.");
            partnerUnsubscribe();
          };

        } else {
          console.log("ComposeLetter: No partnerId found in user document.");
          setPartner(null);
        }
      } else {
        console.log("ComposeLetter: Current user document not found.");
      }
    });

    return () => {
      console.log("ComposeLetter: Unsubscribing from user listener.");
      unsubscribe();
    };
  }, []);

  const handleSend = async () => {
    if (!recipient || !message) {
      alert('Please write a message.');
      return;
    }

    // Use current user's nickname as the signature if not empty, otherwise use "Anonymous"
    const signature = fromName.trim() || currentUserNickname.trim() || 'Anonymous';

    await addDoc(collection(db, 'letters'), {
      from: auth.currentUser.uid,
      fromName: signature,
      to: recipient,
      message: message,
      createdAt: new Date(),
      isRead: false,
    });

    setMessage('');
    setFromName('');
    if (onLetterSent) {
      onLetterSent();
    }
  };

  return (
    <div className="compose-letter-container">
      <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&display=swap" rel="stylesheet" />
      <h2>Write a New Letter</h2>
      <div className="letter-form">
        {partner ? (
          <div className="form-group">
            <label>To:</label>
            <input type="text" value={partner.nickname || partner.email} readOnly disabled />
          </div>
        ) : (
           <p>You are not linked with a partner yet.</p>
        )}
        
        <div className="form-group">
          <label>Message:</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Write your letter here..."
          />
        </div>

        <div className="form-group">
          <label>Signature:</label>
          <input
            type="text"
            value={fromName}
            onChange={(e) => setFromName(e.target.value)}
            placeholder={currentUserNickname || "Your name"}
          />
        </div>

        <div className="compose-actions">
            <button onClick={onBack} className="back-button-compose">Back</button>
            <button onClick={handleSend} className="send-button" disabled={!partner}>Send</button>
        </div>
      </div>
    </div>
  );
};

export default ComposeLetter;
